import { AddSwiggyMoneyProps } from "@payment-ui/interfaces";
import React, { memo, ReactElement } from "react";
import { default as AddSwiggyMoneyV4 } from "./v4/AddSwiggyMoney";

function AddSwiggyMoney(props: AddSwiggyMoneyProps): ReactElement {
    return <AddSwiggyMoneyV4 {...props} />;
}

export default memo(AddSwiggyMoney);
